"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataTable = void 0;

var _DataTable = _interopRequireDefault(require("./DataTable"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataTable = {
  Table: _DataTable.default,
  sortBy: _utils.sortBy,
  filterByExactly: _utils.filterByExactly,
  filterByContaining: _utils.filterByContaining,
  useControllableTable: _utils.useControllableTable
};
exports.DataTable = DataTable;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/containers/data_table/index.js
// module id = 772
// module chunks = 0 15 16 17 18